// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__r8F5E","contactDetails":"footer_contactDetails__O1mSN"};